import { DomItem } from "../domItem"
import { IDateViewModel, IFieldYearViewModel, TimelineViewModel } from "../types"

export function getCroppingStyle(vm: TimelineViewModel, i: DomItem | IFieldYearViewModel, relativeTop = 0) {

    const scale = getDurationScale(vm)
    const width = scale * i.width
    const left = offsetX((scale * i.left), vm)

    return {
        left: left + 'px',
        top: (i.top - (relativeTop || 0)) + 'px',
        height: i.height + 'px',
        width: width + 'px',
    }
}

export function getCroppingInnerStyle(vm: TimelineViewModel, i: DomItem) {
    const scale = getDurationScale(vm)
    const width = scale * i.width
    return {
        'max-width': width + 'px',
    }
}

export function getCroppingDescription(vm: TimelineViewModel, i: DomItem, debug: boolean) {
    const scale = getDurationScale(vm)
    const width = scale * i.width
    return i.getDescription(width < 200, debug)
}

export function getFieldName(i: DomItem, debug: boolean) {

    const { vm } = i

    return vm
        ? (debug ? `(#${vm.fieldId}) ` : "") + vm.fieldName
        : null


}

export function getFieldDescription(i: DomItem, debug: boolean) {

    const { vm } = i

    return vm
        ? (debug ? `(#${vm.fieldId}) ` : "") + vm.description
        : null

}

export function getDateStyle(vm: TimelineViewModel, i: IDateViewModel, index: number) {

    const scale = getDurationScale(vm)

    if ((scale < 0.9) && (index % 2)) {
        return {
            display: "none"
        }
    }

    return {
        left: offsetX((scale * i.left), vm) + 'px',
    }
}

export function getDisabledYearContent(vm: TimelineViewModel, i: IFieldYearViewModel) {
    const scale = vm.getDurationScale()
    const width = i.width * scale

    if (width < 250) {
        const msg = `Disabled in ${i.target.year}`
        return msg
    }

    const msg = `Field <strong>${i.target.fieldName}</strong> is disabled during year <strong>${i.target.year}</strong>`

    return `<i class="icon icon-forbidden"></i>` + msg

}

export function getCurrentYearStyle(vm: TimelineViewModel, height = false) {

    if (!vm) return {}

    const scale = getDurationScale(vm)
    const year = vm.cropYear
    const left = offsetX(scale * year.left, vm)
    const width = year.width * scale

    const style = {
        left: left + 'px',
        width: width + 'px'
    }

    if (height) {
        style["height"] = vm.fullHeight + 'px'
    }

    return style

}

export function getDateCurrentCroppingStyle(vm: TimelineViewModel, cropping: DomItem) {

    if (!cropping) return {}

    const scale = getDurationScale(vm)
    const left = offsetX(scale * cropping.left, vm)
    const width = scale * cropping.width
    return {
        left: left + 'px',
        width: width + 'px',
        'background-color': cropping.color
    }
}

function getDurationScale(vm: TimelineViewModel) {
    return vm ? vm.getDurationScale() : 1
}

function offsetX(x: number, vm: TimelineViewModel) {
    return x + (vm.viewConfig.leftOffset || 0)
}
